<pg-about>
  <section>
    <section id="about">
      <h1>Quem somos</h1>

      <div class="container">
        <p>Oferecemos soluções customizadas para as suas necessidades e objetivos, com a assinatura de excelência VLGI e a agilidade que você precisa.</p>
        <p>Com uma equipe de mais de 20 anos de experiência no mercado financeiro e no segmento Corporate, cuidamos do seu patrimônio através da proximidade e do respeito ao seu perfil e ao da sua empresa.</p>
        <p>Atuamos fazendo a intermediação entre a sua empresa e as instituições financeiras, trazendo as soluções mais adequadas para alcançar os melhores resultados no seu negócio.</p>
      </div>
    </section>

    <section class="team-section" id={"pg-team-{team.id}"} each={team in teams}>
      <header>
        <h2>{ team.name }</h2>
      </header>
      <div class="container">
        <div each={ member in team.members} class="item">
          <div class="img-container">
            <img src={ 'media/' + member.avatar } alt="Foto de {member.name}">
            <div class="member-medias">
              <a href={member.linkedin} target="_blank"><i class="icon-linkedin"></i></a>
            </div>
          </div>
          <span class="member-name">{ member.name }</span>
          <span class="member-function">{ member.title }</span>
        </div>
      </div>
    </section>
  </section>

  <script>
    import './pg-about.scss'

    import teams from '../components/teams'

    export default {
      teams,
      onMounted() {
        this.breakNameLine()
      },
      onUpdated() {
        this.breakNameLine()
      },
      breakNameLine() {
        const names = this.$$('.member-name')
        names.forEach(x => {
          x.innerHTML = x.innerText
        })
      }
    }
  </script>
</pg-about>
